var exports = {
  "o": "ForumPostActions.module__actions___ZVJ4al",
};

module.exports = exports;
